import { SubscriptionStorage } from '@/storage/SubscriptionStorage';

export default defineNuxtPlugin(() => {
    // Remove passwords persisted by older app versions, even outside registration.
    SubscriptionStorage.removePersistedPassword();
});
